export var MeshType;
(function (MeshType) {
    MeshType["Box"] = "Box";
    MeshType["Sphere"] = "Sphere";
    MeshType["Cylinder"] = "Cylinder";
    MeshType["Torus"] = "Torus";
})(MeshType || (MeshType = {}));
